module.exports = __webpack_public_path__ + "front/img/75.6ebe9455.png";